const $ = jQuery;

$('.h2rt-body').hide();

//import("bootstrap")
require('./style.scss')

let files = [];

function renderFiles() {

    let filesContainer = $('#files-container');
    filesContainer.html("");

    files.forEach(function (file, index) {

        filesContainer.append(`
        
        <div class="file-item p-2 border-1 border mb-2 rounded-2 border-dark">
            <div class="name text-primary">
                ${file.name}
            </div>
            <div class="d-flex gap-4 align-items-end text-secondary">
                <div>
                    ${(file.size/1024).toFixed(2)} KB
                </div>
                <div class="fw-bold">
                    ${file.type.split("/")[1].toUpperCase()}
                </div>
                <span style="flex: 1;"></span>
                <div>
                    <button data-index="${index}" type="button" class="btn btn-danger btn-sm file-remove">Supprimer</button>
                </div>
            </div>
        </div>
        
        `);

    });

}

function addFiles(list) {

    Array.from(list).forEach(function (item) {
        files.push(item);
    });

    renderFiles();
}

$(document).ready(function () {

    const  errorsDisplayer = $('#errors-displayer');
    errorsDisplayer.html("");

    $(document).on('click', '.file-input', function (e) {
        e.stopImmediatePropagation();
        $(this).find('.file-field').first().trigger('click');
    });

    const fileFields = $('.file-field');
    fileFields.on('click', function (e) {
        e.stopImmediatePropagation()
    });

    fileFields.change(function (e) {

        addFiles(e.target.files);

    });

    $(document).on('click', '.file-remove', function (e) {
        e.stopImmediatePropagation();
        const index = $(this).data('index');
        files.splice(index, 1);
        renderFiles();
    });



    $('#join-us-form').on('submit', function (e) {

        errorsDisplayer.html("");
        e.preventDefault();
        const form = $(this);
        const submitter = form.find('button[type="submit"]');
        const formData = new FormData(this);
        const action = form.attr('action');
        const route = form.data('ajax');

        submitter.attr('disabled', true);
        submitter.text("Traitement en cours ...")

        files.forEach(function (file,index) {
            formData.append(`files[${index}]`,file);
        });

        // data['files'] = files;
        formData.append("action", action);
        formData.append("nonce", form.data('nonce'));

        $.ajax({
            url: route,
            data: formData,
            cache: false,
            contentType: false,
            processData: false,
            method: 'POST',
            success: function (response) {

                //errorsDisplayer.html('');

                if (response.success){
                    form.hide();
                    files = [];
                    errorsDisplayer.html(`<div class="alert alert-success">${response.data.message}</div>`);
                }else {

                    if (response.data.violations !== undefined){

                        $('#errors-displayer').show();
                        response.data.violations.forEach(function (violation) {

                            $('#errors-displayer').append(`
                            
                                <div class="alert alert-danger">${violation.error}</div>
                                
                            `);

                        });

                    }else {
                        $('#errors-displayer').append(`<div class="alert alert-danger">${response.data.message}</div>`)
                    }

                }


                submitter.attr('disabled', false);
                submitter.text("Je postule");

            },
            error: function (error) {

                $('#errors-displayer').append(`<div class="alert alert-danger">Oups une erreur est survenu veuillez réessayer !</div>`)

                submitter.attr('disabled', false);
                submitter.text("Je postule");

            }
        });

    })

});